module.exports = __webpack_public_path__ + "img/truck_02.1b0e8d79.jpg";